import { Button, Modal } from 'src/components';
import infoIcon from 'src/assets/icons/Info.svg';

interface IConfirmationModal {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  confirmationHeaderText?: string;
  confirmationText: string;
  additionalText?: string;
  confirmationModalType: string;
  modalContainerClassName?: string;
  imageClassName?: string;
}

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  confirmationHeaderText = 'Are You Sure?',
  confirmationText,
  additionalText,
  confirmationModalType,
  modalContainerClassName,
  imageClassName,
}: IConfirmationModal) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className={`max-w-[546px] w-[546px] h-[460px] min-w-[80px] p-8 rounded-xl shadow ${modalContainerClassName}`}
      position="center"
      header={<></>}
    >
      <div className="flex flex-col h-full justify-center items-center">
        {/* <img
          src={infoIcon}
          alt="delete icon"
          className={`w-[132px] pb-[26px] mb-[-10px] ${imageClassName}`}
        /> */}
        <h1 className="text-blue-950 text-[24px] font-medium font-SFProDisplay mt-0 mb-2">
          {confirmationHeaderText}
        </h1>
        <p className="text-blue-950 text-sm font-normal font-SFProDisplay text-center pl-3 pr-3">
          {confirmationText}
        </p>
        {additionalText && (
          <p className="font-medium text-sm mb-3 font-SFProDisplay text-center pl-3 pr-3 text-blue-950 ">
            {additionalText}
          </p>
        )}

        <div className="flex gap-3 mt-[24px]">
          {confirmationModalType === 'errorPopup' ? (
            <>
              <Button
                label="Cancel"
                variant="normal"
                size="md"
                className="h-[32px] mt-0 flex items-center justify-center w-[96px] text-white text-sm font-normal font-SFProDisplay"
                type="button"
                disabled={false}
                onClick={onClose}
              />
            </>
          ) : (
            <>
              <Button
                label="No"
                variant="secondary"
                size="md"
                className="h-[32px] mt-0 flex items-center justify-center w-[83px] font-SFProDisplay text-indigo-600 text-sm font-normal"
                type="button"
                disabled={false}
                onClick={onClose}
              />
              <Button
                label="Yes"
                variant="normal"
                size="md"
                className="h-[32px] mt-0 flex items-center justify-center w-[96px] text-white text-sm font-normal font-SFProDisplay"
                type="button"
                disabled={false}
                onClick={onConfirm}
              />
            </>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
